<div class="round-percentage">
  <div
    class="round-percentage-circle flex-row justify-center align-center"
  >
    <div class="round-percentage-value">{{ value | translocoDecimal }} {{ unity }}</div>
  </div>

  <div class="round-percentage-label">{{ label }}</div>
</div>
